<template>
  <div class="flex min-w-[312px] flex-col overflow-hidden bg-primary">
    <button
      type="button"
      class="ml-auto mr-5 mt-2 flex size-10 items-center justify-center md:hidden"
      @click="emit('close')"
    >
      <UiIcon name="x-mark" class="size-5 text-icon-primary" />
    </button>
    <header sticky class="bg-transparent px-6 md:p-6 md:pb-3">
      <FilterLocationsList
        v-model.trim="filterString"
        :is-page="isPage"
        :pinned-locations
        :current-location
        @close="emit('close')"
        @update:model-value="page = 1"
      />
    </header>

    <div
      class="scrollbar-hidden relative mt-3 h-full overflow-y-scroll rounded-t-xl border-primary bg-primary py-3 md:m-0 md:mx-3 md:min-w-[360px] md:border md:border-transparent md:p-0"
      :class="{ 'px-2 md:px-2': !isPage }"
    >
      <template v-if="!searchIsEmpty">
        <ul class="flex flex-col gap-2 pb-2">
          <li v-for="(locationList, char) in showingLocations" :key="char">
            <p class="box-content h-9 px-4 py-1.5 text-base text-text-tertiary">
              {{ char }}
            </p>
            <LocationList :value="locationList" :current-location @click="chooseLocation" />
          </li>
        </ul>
        <UiEternalLoading
          v-if="!allItemsIsVisible"
          :handler="loadNextPage"
          :all-loaded="allItemsIsVisible"
        />
      </template>
      <p
        v-else
        class="m-auto flex h-full items-center justify-center px-3.5 text-center text-sm md:h-[320px]"
      >
        Не нашли мероприятий в этом городе.<br />Попробуйте выбрать другой
      </p>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import { ref, computed } from 'vue'
import { getLocationName, LocationList, useLocation } from '@/5_entities/Location'
import type { Location } from '@/5_entities/Location'
import { useUser } from '@/5_entities/User'
import { usePageInfiniteLoading } from '@/6_shared/composables'
import { UiEternalLoading, UiIcon } from '@/6_shared/ui'
import FilterLocationsList from './FilterLocationsList.vue'

type PropType = {
  isPage?: boolean
}
type EmitType = {
  (e: 'close'): void
}

withDefaults(defineProps<PropType>(), {
  isPage: false,
  isPopover: false
})
const emit = defineEmits<EmitType>()

const { locations, pinnedLocations, currentLocation } = storeToRefs(useLocation())
const { getLocationsByChar, setLocation } = useLocation()
const { updateUserLocation } = useUser()

const filterString = ref('')
const searchIsEmpty = computed(() => !Object.keys(filteredList.value).length)

const filteredList = computed((): Location[] => {
  if (!locations.value) return []

  if (!filterString.value) return locations.value

  return locations.value.filter((item) => {
    const location = getLocationName(item).toUpperCase()

    return location.includes(filterString.value.toUpperCase())
  })
})
const showingLocations = computed(() =>
  showingItems.value ? getLocationsByChar(showingItems.value) : {}
)

const PAGE_SIZE_BY_CITY = 30
const page = ref(1)
const { showingItems, allItemsIsVisible, loadNextPage } = usePageInfiniteLoading<Location>(
  PAGE_SIZE_BY_CITY,
  page,
  filteredList
)

const chooseLocation = (location: Location) => {
  updateUserLocation(location).then(() => setLocation(location))

  emit('close')
}
</script>
